export const GENDER_TRANSFORM = {
    0: 'Open',
    1: 'Mixed',
    2: 'Women',
    3: 'Boys',
    4: 'Girls'
};

// Keys are the Go teams.Division enum values (api/teams/models.go). They are
// persisted as integers, so these are append-only and must never be
// renumbered -- see ultidb/docs/ingest-contract.md section 4.
export const DIVISIONS_TRANSFORM = {
    0: 'College',
    1: 'Club',
    2: 'Youth Club U-20',
    3: 'Youth Club U-17',
    4: 'Other',
    5: 'Masters',
    6: 'Grand Masters',
    7: 'Great Grand Masters',
    8: 'International',
    9: 'International U-20',
    10: 'International U-24'
};

// Short age/level prefix for the compact DivisionChip, which renders
// "<prefix><gender>" in a narrow table column. Blank where the division adds
// nothing a reader needs at a glance (College/Club/Other are the common case,
// and International is implied by the event itself).
export const DIVISION_CHIP_PREFIX = {
    0: '',
    1: '',
    2: 'U20 ',
    3: 'U17 ',
    4: '',
    5: 'Masters ',
    6: 'GM ',
    7: 'GGM ',
    8: '',
    9: 'U20 ',
    10: 'U24 '
};

export const STAGES_TRANSFORM = {
    0: 'Pools',
    1: 'Bracket',
    2: 'Cluster'
};
